export const REGEX = {
    NUMBER: '[0-9]{16}',
    PASSWORD: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$',
    MOBILE: '[6-9]{1}[0-9]{9}',
    EMAIL: '^[a-zA-Z0-9_.-]+@[a-zA-Z0-9]+[a-zA-Z0-9.-]+[a-zA-Z0-9]+\.[a-z]{1,3}$',
    AADHAAR: '[1-9]{11}[0-9]{1}',
    PAN: '[A-Z]{5}[0-9]{4}[A-Z]{1}',
    TAN: '[A-Z]{4}[0-9]{5}[A-Z]{1}',
    GST: '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$',
    PIN: '[1-9]{1}[0-9]{5}',
    CIN: '^([L|U]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$',
    DIN: '[1-9]{1}[0-9]{7}',
    NONZERO: '^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$',
    PASSPORT: '[A-PR-WYa-pr-wy][1-9]\\d\\s?\\d{4}[1-9]$',
    // WEBSITE: '^(?:http(s)?:\\/\\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&\(\)\*\+,;=.]+$'
    WEBSITE: '(https?)?:\\/\\/(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)',
    CARDTYPE: {
      VISA: "^4[0-9]{12}(?:[0-9]{3})?$",
      MASTERCARD: "^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$",
      AMERICANEXPRESS: "^3[47][0-9]{13}$",
      DISCOVER: "^6(?:011|5[0-9]{2})[0-9]{12}$",
      DINERSCLUB: "^3(?:0[0-5]|[68][0-9])[0-9]{11}$",
      DINERSCARTEBLANCHE: "^30[0-5]",
      JCB: "^(?:2131|1800|35\d{3})\d{11}$",
    },
    UPI: "^[a-zA-Z0-9._-]+@[a-zA-Z]+$"
}